/**
 * Keep canonical URLs for navigation/storage; shorten only the SMS copy.
 *
 * Only OUR list links lose "https://": the production app host plus whatever
 * host this build serves /s/ on (staging/local). It now runs at the send
 * chokepoint (F27), so a hand-typed third-party link that happens to have an
 * /s/<code> path must go out exactly as typed.
 */
const PRODUCTION_LIST_HOST = "app.locatenowatl.com";

function listHosts(): Set<string> {
  const hosts = new Set([PRODUCTION_LIST_HOST]);
  try {
    // Lazy: importing this helper must not require a validated environment.
    const { runtimeEnvironment } = require("./runtimeEnvironment");
    const host = new URL(runtimeEnvironment.publicAppUrl).hostname;
    if (host) hosts.add(host.toLowerCase());
  } catch {
    // No environment (e.g. an isolated unit test): production host only.
  }
  return hosts;
}

export function smsShortlistLinks(body: string): string {
  const hosts = listHosts();
  return body.replace(
    /\bhttps?:\/\/([^\s/]+)(?=\/s\/[A-Za-z0-9_-]+)/gi,
    (match, host: string) => (hosts.has(host.toLowerCase()) ? host : match),
  );
}
